import React, { memo, useMemo } from 'react';
import { Icon, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import ReadOnlyTooltipContent from 'components/ReadOnlyIndicator/ReadOnlyTooltipContent';

import './styles.scss';

const PublicAccountIndicator = memo(({ isPublic, isReadOnly }) => {
    const theme = useTheme();

    const indicatorConfig = useMemo(() => {
        if (isPublic && isReadOnly) {
            return {
                iconName: 'publicLock',
                content: <ReadOnlyTooltipContent isPublicCompany />,
            };
        }

        if (isPublic) {
            return {
                iconName: 'public',
                content: (
                    <div className="fm-public-account-indicator__content">
                        <Text className="fm-public-account-indicator__title" type="subtitle" medium>
                            {getLiteral('label_detail_public_account')}
                        </Text>
                        <Text
                            className="fm-public-account-indicator__description"
                            color={theme.colors.utility.textSecondary}
                        >
                            {getLiteral('label_detail_public_account_desc')}
                        </Text>
                    </div>
                ),
            };
        }

        if (isReadOnly) {
            return {
                iconName: 'lock',
                content: <ReadOnlyTooltipContent />,
            };
        }

        return null;
    }, [isPublic, isReadOnly, theme.colors.utility.textSecondary]);

    if (!indicatorConfig) return null;

    return (
        <Popover
            className="fm-public-account-indicator"
            placement="bottom"
            content={indicatorConfig.content}
            trigger={['hover']}
        >
            <div className="fm-public-account-indicator__icon">
                <Icon name={indicatorConfig.iconName} color={theme.colors.grey[500]} />
            </div>
        </Popover>
    );
});

export default PublicAccountIndicator;
